import { render } from "./MetalabExperienceComponent.vue?vue&type=template&id=5e594a6b&scoped=true"
import script from "./MetalabExperienceComponent.js?vue&type=script&lang=js"
export * from "./MetalabExperienceComponent.js?vue&type=script&lang=js"

import "./MetalabExperienceComponent.scss?vue&type=style&index=0&id=5e594a6b&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e594a6b"]])

export default __exports__